jQuery(function ($) {
  /***************************************
   * Prefill contact form with object title
   ***************************************/
  function fillContactFormObjectTitle() {
    var $form = $(".single-object__sidebar.contact-form");
    var title = $form.attr("data-object-title");
    var $field = $form.find("#twb-form-field-field_1790687277316");

    if (!title || !$field.length) {
      return;
    }

    $field.val(title);
  }

  fillContactFormObjectTitle();

  /***************************************
   * Read more
   ***************************************/
  $(".single-object__content__description__content").on("click", function () {
    $(
      ".single-object__content__description__content__collapsed, .read-more"
    ).hide();
    $(".single-object__content__description__content__expanded").show();
  });

  /***************************************
   * Image gallery popup
   ***************************************/
  $(".gallery-image").magnificPopup({
    type: "image",
    gallery: {
      enabled: true,
      navigateByImgClick: true,
      preload: [1, 2],
    },
  });

  /***************************************
   * Video gallery popup
   ***************************************/
  function loadPopupVideo($container) {
    $container.find("video").each(function () {
      var video = this;
      var $video = $(video);
      var $source = $video.find("source");
      var src = $source.attr("data-src") || $video.attr("data-src");

      if (!src) {
        return;
      }

      if ($source.length) {
        $source.attr("src", src);
      }
      $video.attr("src", src);
      video.load();
      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === "function") {
        playPromise.catch(function () {});
      }
    });
  }

  function unloadPopupVideo($container) {
    $container.find("video").each(function () {
      this.pause();
      this.removeAttribute("src");
      $(this).find("source").removeAttr("src");
      this.load();
    });
  }

  $(".gallery-video").magnificPopup({
    type: "inline",
    midClick: true,
    mainClass: "mfp-video-popup",
    gallery: {
      enabled: true,
    },
    callbacks: {
      beforeChange: function () {
        if (this.content) {
          unloadPopupVideo(this.content);
        }
      },
      change: function () {
        loadPopupVideo(this.content);
      },
      close: function () {
        unloadPopupVideo(this.content);
      },
    },
  });

  /***************************************
   * Floorplan gallery popup
   ***************************************/
  $(".gallery-floorplan").magnificPopup({
    type: "image",
    gallery: {
      enabled: true,
      navigateByImgClick: true,
      preload: [1, 2],
    },
    callbacks: {
      elementParse: function (item) {
        item.type = /\.pdf($|\?)/i.test(item.src) ? "iframe" : "image";
      },
    },
  });

  function openFirstGalleryItem(selector) {
    const $first = $(selector).first();
    if ($first.length) {
      $first.trigger("click");
    }
  }

  $(".js-open-photos").on("click", function (e) {
    e.preventDefault();
    openFirstGalleryItem(".gallery-image");
  });

  $(".js-open-videos").on("click", function (e) {
    e.preventDefault();
    openFirstGalleryItem(".gallery-video");
  });

  $(".js-open-floorplans").on("click", function (e) {
    e.preventDefault();
    openFirstGalleryItem(".gallery-floorplan");
  });

  /***************************************
   * 360° panorama popup
   ***************************************/
  var panoramaViewer = null;
  var panoramaConfig = null;
  var panoramaSceneIds = [];
  var pendingSceneDelta = 0;

  function sizeObjectPanorama() {
    var popup = document.getElementById("object-panorama-popup");
    if (!popup) {
      return;
    }

    var verticalPadding = 80;
    var maxWidth = Math.max(window.innerWidth - 16, 0);
    var contentHeight = Math.max(window.innerHeight - verticalPadding, 0);
    var contentWidth = Math.round(contentHeight * 1.5);

    if (contentWidth > maxWidth) {
      contentWidth = maxWidth;
      contentHeight = Math.round(contentWidth / 1.5);
    }

    popup.style.width = contentWidth + "px";
    popup.style.height = contentHeight + verticalPadding + "px";
  }

  function updatePanoramaChrome() {
    var popup = document.getElementById("object-panorama-popup");
    if (!popup || !panoramaViewer) {
      return;
    }

    var index = panoramaSceneIds.indexOf(panoramaViewer.getScene());
    if (index < 0) {
      index = 0;
    }

    var scene = (panoramaConfig.scenes || {})[panoramaSceneIds[index]] || {};
    var title = popup.querySelector(".mfp-title");
    var counter = popup.querySelector(".mfp-counter");

    if (title) {
      title.textContent = scene.title || "";
    }
    if (counter) {
      counter.textContent = index + 1 + " of " + panoramaSceneIds.length;
    }
  }

  function shiftPanoramaScene(delta) {
    if (!panoramaViewer || panoramaSceneIds.length < 2) {
      return;
    }

    if (typeof panoramaViewer.isLoaded === "function" && !panoramaViewer.isLoaded()) {
      pendingSceneDelta += delta;
      return;
    }

    var index = panoramaSceneIds.indexOf(panoramaViewer.getScene());
    if (index < 0) {
      index = 0;
    }

    var next = (index + delta + panoramaSceneIds.length) % panoramaSceneIds.length;
    panoramaViewer.loadScene(panoramaSceneIds[next]);
    updatePanoramaChrome();
  }

  function onPanoramaKeydown(event) {
    if (event.key !== "ArrowLeft" && event.key !== "ArrowRight") {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    shiftPanoramaScene(event.key === "ArrowLeft" ? -1 : 1);
  }

  function removePanoramaArrows() {
    $(".mfp-arrow--scene").remove();
  }

  function destroyObjectPanorama() {
    document.removeEventListener("keydown", onPanoramaKeydown, true);
    $(window).off("resize.panorama");
    removePanoramaArrows();
    pendingSceneDelta = 0;
    if (panoramaViewer && typeof panoramaViewer.destroy === "function") {
      panoramaViewer.destroy();
    }
    panoramaViewer = null;
  }

  function addPanoramaArrow(container, direction, delta) {
    var button = document.createElement("button");
    button.type = "button";
    button.className = "mfp-arrow mfp-arrow-" + direction + " mfp-arrow--scene";
    button.title = direction === "left" ? "Previous (Left arrow key)" : "Next (Right arrow key)";
    button.setAttribute("aria-label", button.title);
    button.addEventListener("mousedown", function (event) {
      event.stopPropagation();
    });
    button.addEventListener("touchstart", function (event) {
      event.stopPropagation();
    });
    button.addEventListener("click", function (event) {
      event.preventDefault();
      event.stopPropagation();
      shiftPanoramaScene(delta);
    });
    container.appendChild(button);
  }

  function initObjectPanorama() {
    if (typeof pannellum === "undefined") {
      return;
    }

    var configNode = document.getElementById("object-panorama-config");
    var target = document.getElementById("object-panorama");
    if (!configNode || !target) {
      return;
    }

    panoramaConfig = JSON.parse(configNode.textContent || "{}");
    panoramaSceneIds = Object.keys(panoramaConfig.scenes || {});
    if (!panoramaSceneIds.length) {
      return;
    }

    destroyObjectPanorama();
    sizeObjectPanorama();
    panoramaViewer = pannellum.viewer(target, {
      default: {
        firstScene: panoramaConfig.firstScene || panoramaSceneIds[0],
        sceneFadeDuration: 800,
        autoLoad: true,
        autoRotate: 2,
        autoRotateInactivityDelay: 3000,
        showZoomCtrl: false,
        showFullscreenCtrl: false,
      },
      scenes: panoramaConfig.scenes,
    });
    panoramaViewer.on("load", function () {
      if (!pendingSceneDelta) {
        updatePanoramaChrome();
        return;
      }

      var delta = pendingSceneDelta;
      pendingSceneDelta = 0;
      shiftPanoramaScene(delta);
    });
    updatePanoramaChrome();

    $(window).on("resize.panorama", function () {
      sizeObjectPanorama();
      if (panoramaViewer && typeof panoramaViewer.resize === "function") {
        panoramaViewer.resize();
      }
    });

    if (panoramaSceneIds.length < 2) {
      return;
    }

    var container = document.querySelector(".mfp-panorama-popup .mfp-container");
    if (!container) {
      return;
    }

    addPanoramaArrow(container, "left", -1);
    addPanoramaArrow(container, "right", 1);
    document.addEventListener("keydown", onPanoramaKeydown, true);
  }

  $(".gallery-360").magnificPopup({
    type: "inline",
    midClick: true,
    mainClass: "mfp-panorama-popup",
    callbacks: {
      open: function () {
        initObjectPanorama();
      },
      close: function () {
        destroyObjectPanorama();
      },
    },
  });

  $(".js-open-photos_360").on("click", function (e) {
    e.preventDefault();
    openFirstGalleryItem(".gallery-360");
  });
});
